(() => {
  'use strict';
  const dialog = document.getElementById('ap-wishlist');
  if (!dialog || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const messages = dialog.dataset;
  const key = `ap-wishlist-v1:${messages.shop}`;
  const list = dialog.querySelector('[data-ap-wishlist-list]');
  const status = document.querySelector('[data-ap-wishlist-status]');
  let items = [];
  let timer;
  let opener;
  let previousOverflow = '';
  const root = messages.root.replace(/\/$/, '');
  const productUrl = handle => `${root}/products/${encodeURIComponent(handle)}`;
  const valid = item => item && typeof item.handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(item.handle) && typeof item.title === 'string';
  function read() {
    try {
      const stored = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(stored) ? stored.filter(valid).filter((item, index, all) => all.findIndex(other => other.handle === item.handle) === index).slice(0, 200) : [];
    } catch { return []; }
  }
  function announce(message) {
    clearTimeout(timer);
    status.textContent = message;
    timer = setTimeout(() => { status.textContent = ''; }, 3500);
  }
  function sync() {
    document.querySelectorAll('[data-ap-wishlist-count], [data-ap-wishlist-total]').forEach(node => {
      if (node.textContent !== String(items.length)) node.textContent = String(items.length);
      if (node.hasAttribute('data-ap-wishlist-count')) node.hidden = items.length === 0;
    });
    document.querySelectorAll('[data-ap-wishlist-toggle]').forEach(button => {
      const saved = items.some(item => item.handle === button.dataset.handle);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${saved ? messages.remove : messages.save}: ${button.dataset.title}`);
      const label = button.querySelector('[data-ap-wishlist-label]');
      const text = saved ? messages.saved : messages.save;
      if (label && label.textContent !== text) label.textContent = text;
    });
  }
  function commit(next, message) {
    try { localStorage.setItem(key, JSON.stringify(next)); }
    catch { announce(messages.storageError); return false; }
    items = next;
    sync();
    if (message) announce(message);
    return true;
  }
  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }
  function safeImage(value) {
    if (!value) return '';
    try {
      const url = new URL(value, location.origin);
      return url.protocol === 'https:' || url.origin === location.origin ? url.href : '';
    } catch { return ''; }
  }
  async function refresh(item, row, name, image, price, vendor, details, availability, view) {
    price.textContent = messages.loading;
    try {
      const response = await fetch(`${productUrl(item.handle)}.js`, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Unavailable');
      const product = await response.json();
      if (!row.isConnected) return;
      name.textContent = product.title;
      vendor.textContent = product.vendor || '';
      vendor.hidden = !product.vendor;
      const options = Array.isArray(product.options) ? product.options.filter(option => option.name !== 'Title') : [];
      details.textContent = options.map(option => `${option.name}: ${option.values.slice(0, 3).join(' / ')}${option.values.length > 3 ? '…' : ''}`).join(' · ');
      details.hidden = !details.textContent;
      view.textContent = product.variants.length > 1 ? messages.options : messages.view;
      const src = safeImage(product.featured_image || '');
      if (src) image.src = src;
      image.alt = product.title;
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: messages.currency });
      const formatted = formatter.format(product.price_min / 100);
      price.textContent = product.price_varies ? `${messages.from} ${formatted}` : formatted;
      availability.textContent = product.available ? '' : messages.unavailable;
      availability.hidden = product.available;
    } catch {
      if (!row.isConnected) return;
      price.textContent = messages.unavailable;
      const retry = element('button', 'ap-wishlist__retry', messages.retry);
      retry.type = 'button';
      retry.addEventListener('click', () => { retry.remove(); refresh(item, row, name, image, price, vendor, details, availability, view); });
      price.append(' ', retry);
    }
  }
  function render(focusIndex) {
    list.replaceChildren();
    dialog.querySelector('[data-ap-wishlist-empty]').hidden = items.length !== 0;
    dialog.classList.toggle('ap-wishlist--empty', items.length === 0);
    items.forEach((item, index) => {
      const row = element('li', 'ap-wishlist__item');
      const imageLink = element('a', 'ap-wishlist__image-link');
      imageLink.href = productUrl(item.handle);
      imageLink.tabIndex = -1;
      imageLink.setAttribute('aria-hidden', 'true');
      const image = element('img', 'ap-wishlist__image');
      image.width = 144;
      image.height = 144;
      image.alt = '';
      const src = safeImage(item.image || '');
      if (src) image.src = src;
      imageLink.append(image);
      const body = element('div', 'ap-wishlist__details');
      const vendor = element('p', 'ap-wishlist__vendor', item.vendor || '');
      vendor.hidden = !item.vendor;
      const name = element('a', 'ap-wishlist__name', item.title);
      name.href = productUrl(item.handle);
      const price = element('p', 'ap-wishlist__price');
      const details = element('p', 'ap-wishlist__options');
      details.hidden = true;
      const availability = element('p', 'ap-wishlist__availability');
      availability.hidden = true;
      const actions = element('div', 'ap-wishlist__actions');
      const view = element('a', 'ap-wishlist__view', messages.view);
      view.href = productUrl(item.handle);
      const remove = element('button', 'ap-wishlist__remove');
      const trash = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      trash.setAttribute('viewBox', '0 0 24 24');
      trash.setAttribute('fill', 'none');
      trash.setAttribute('stroke', 'currentColor');
      trash.setAttribute('stroke-width', '1.7');
      trash.setAttribute('stroke-linecap', 'round');
      trash.setAttribute('stroke-linejoin', 'round');
      trash.setAttribute('aria-hidden', 'true');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7');
      trash.append(path);
      remove.append(trash);
      remove.type = 'button';
      remove.setAttribute('aria-label', `${messages.remove}: ${item.title}`);
      remove.title = messages.remove;
      remove.addEventListener('click', () => {
        if (commit(items.filter(saved => saved.handle !== item.handle), messages.removed)) render(index);
      });
      actions.append(view, remove);
      body.append(vendor, name, price, details, availability, actions);
      row.append(imageLink, body);
      list.append(row);
      refresh(item, row, name, image, price, vendor, details, availability, view);
    });
    if (focusIndex !== undefined) {
      const buttons = list.querySelectorAll('.ap-wishlist__remove');
      (buttons[Math.min(focusIndex, buttons.length - 1)] || dialog.querySelector('[data-ap-wishlist-close]')).focus();
    }
  }
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-ap-wishlist-open]');
    if (open) {
      opener = open;
      items = read();
      sync();
      render();
      if (!dialog.open) {
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        dialog.showModal();
      }
      return;
    }
    const button = event.target.closest('[data-ap-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    const item = { handle: button.dataset.handle, title: button.dataset.title, vendor: button.dataset.vendor || '', image: button.dataset.image || '' };
    if (!valid(item)) return;
    items = read();
    const saved = items.some(entry => entry.handle === item.handle);
    const next = saved ? items.filter(entry => entry.handle !== item.handle) : [item, ...items].slice(0, 200);
    commit(next, saved ? messages.removed : messages.added);
  });
  dialog.querySelector('[data-ap-wishlist-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    if (opener?.isConnected) opener.focus();
  });
  window.addEventListener('storage', event => {
    if (event.key === key || event.key === null) { items = read(); sync(); if (dialog.open) render(); }
  });
  new MutationObserver(() => sync()).observe(document.body, { childList: true, subtree: true });
  items = read();
  sync();
})();
